import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
Vue.use(Vuex);
const API_ROOT = '/AMVBtool_v2/api/';
export default new Vuex.Store({
    state: {
        errorMessage: '',
        currentUser: {},
    },
    mutations: {
        setErrorMessage(state, message) {
            state.errorMessage = message;
        },
        clearErrorMessage(state) {
            state.errorMessage = '';
        },
        setCurrentUser(state, currentuser) {
            state.currentUser = currentuser;
        }
    },
    actions: {
        getCurrentUser({ commit }) {
            axios.get('auth/current')
                .then(response => {
                if (response.data.user) {
                    commit('setCurrentUser', response.data.user);
                }
            }).catch(function (error) {
                localStorage.clear();
                window.location.replace('/AMVBtool_v2/login');
            });
        },
        loginUser({ commit }, user) {
            commit('clearErrorMessage');
            axios.defaults.baseURL = process.env.VUE_API_ROOT;
            axios.post(API_ROOT + 'auth/login', {
                email: user.email,
                password: user.password
            })
                .then(response => {
                if (response.data.token) {
                    // Save token in localstorage for later use.
                    localStorage.setItem('amvbtool_token', response.data.token);
                    window.location.replace('/AMVBtool_v2/tool');
                }
            })
                .catch(error => {
                commit('setErrorMessage', 'Auth.LoginFailed');
            });
        },
        logoutUser({}) {
            axios.post('auth/logout')
                .then(response => {
                localStorage.clear();
                window.location.replace('/AMVBtool_v2/login');
            })
                .catch(error => {
                console.log(error);
            });
        }
    }
});
